export function isBlankOrEmpty(value?: string | null): boolean {
  if (!value) {
    return true
  }
  const trimmedValue = value.trim()
  return trimmedValue.length == 0
}

export function isNotBlank(value?: string | null): boolean {
  return !isBlankOrEmpty(value)
}

export function normalizeSearch(value?: string | null): string {
  if (!value) return ''
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
}
